// 浏览器环境下才需要这些操作

export const appendInHead = (ele: HTMLElement) => {
  try {
    // 浏览器环境下才需要这步操作
    document.getElementsByTagName('head')[0].appendChild(ele);
  } catch (e) {}
};

export const removeFromDom = (ele: HTMLElement) => {
  try {
    ele.remove();
  } catch (e) {}
};
